/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guarantee_BodyInputs */

const et_guarantee_body = /** @type {(inputs: Guarantee_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meie mudel põhineb igakuisel partnerlusel. Oleme otseselt motiveeritud teie äri kasvatama, sest muidu te meile ei maksa.`)
};

const en_guarantee_body = /** @type {(inputs: Guarantee_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our model is based on monthly partnership. We are directly motivated to grow your business, because otherwise you don't pay us.`)
};

/**
* | output |
* | --- |
* | "Our model is based on monthly partnership. We are directly motivated to grow your business, because otherwise you don't pay us." |
*
* @param {Guarantee_BodyInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const guarantee_body = /** @type {((inputs?: Guarantee_BodyInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guarantee_BodyInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_guarantee_body(inputs)
	return en_guarantee_body(inputs)
});